/** Functions to create mutations. */
import type { Readable } from 'svelte/store';
import type { CreateMutationOptions as CreateMutationOptionsOrStore } from '$lib/api/tanstack-query';

type ExtractStoreVal<T> = T extends Readable<infer ValT> ? ValT : T;

type CreateMutationOptions<TData, TError, TVariables, TContext> =
  ExtractStoreVal<
    CreateMutationOptionsOrStore<TData, TError, TVariables, TContext>
  >;

/**
 * Create a mutation options object.
 *
 * Has no runtime effect.
 * Adds type inference to make options construction safer.
 */
export const createMutationOptions = <
  TData = unknown,
  TError = Error,
  TVariables = void,
  TContext = unknown,
>(
  options: CreateMutationOptions<TData, TError, TVariables, TContext>
): CreateMutationOptions<TData, TError, TVariables, TContext> => {
  return options;
};
